const readModelConnector = () => ({
  connect: null,
  disconnect: null,
  drop: null,
  dispose: null,
})

export default readModelConnector
